import React from 'react';
import cx from 'classnames';

import IconButton from '../IconButton';

import CloseS1 from '../Icons/CloseS1';
import MenuS2 from '../Icons/MenuS2';
import SidebarHide from '../Icons/SidebarHide';
import SidebarShow from '../Icons/SidebarShow';

import useBreakpoints from '../utils/hooks/useBreakpoints';
import { useNavContext } from './NavigationContext';

import styles from './NavigationHeader.module.scss';

export interface NavigationHeaderProps {
  /** Children should contain a `Navigation.Switcher`.  */
  children?: React.ReactNode;
  /** Apply CSS class to the container. */
  className?: Parameters<typeof cx>[0];
}

export const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  children,
  className,
}) => {
  const {
    isCollapsed,
    toggleCollapse,
    isMobileNavOpen,
    toggleMobileNav,
  } = useNavContext();

  // TODO: Refactor to CSS media queries instead of useBreakpoints.
  // https://jira.plaid.com/browse/THREAD-1163
  const { isSmall } = useBreakpoints();

  return (
    <div className={cx(styles.navHeader, className)}>
      {!isCollapsed && children}
      <div className={styles.menuWrapper}>
        {!isSmall && (
          <IconButton
            accessibilityLabel={isCollapsed ? 'Expand Menu' : 'Collapse Menu'}
            icon={isCollapsed ? <SidebarShow /> : <SidebarHide />}
            onClick={toggleCollapse}
          />
        )}
        {isSmall && (
          <IconButton
            accessibilityLabel={
              !isMobileNavOpen ? 'Expand Menu' : 'Collapse Menu'
            }
            icon={isMobileNavOpen ? <CloseS1 /> : <MenuS2 />}
            onClick={toggleMobileNav}
          />
        )}
      </div>
    </div>
  );
};

export default NavigationHeader;
export { styles };
